import { useState } from "react";
import { BookOpen } from "lucide-react";
import { useLang } from "../i18n";
import { Checkbox } from "./ui/checkbox";
import { LegalTextModal } from "./LegalTextModal";
import { MARKETING_DATA_CONSENT, COMMERCIAL_MESSAGE_CONSENT } from "../legal";

// Section A (marketing personal data) + Section B (commercial e-message).
// Two independent, never pre-checked opt-ins. Declining is as easy as consenting.
export function ConsentSections({
  marketingChecked,
  setMarketingChecked,
  commercialChecked,
  setCommercialChecked,
}) {
  const { t } = useLang();
  const [mktOpen, setMktOpen] = useState(false);
  const [comOpen, setComOpen] = useState(false);

  return (
    <div className="space-y-5" data-testid="consent-sections">
      {/* Section A — Marketing personal data consent */}
      <div data-testid="consent-marketing-section">
        <h3 className="text-sm font-semibold text-[#26422A]">
          {MARKETING_DATA_CONSENT.title}
        </h3>
        <button
          type="button"
          data-testid="open-marketing-text-btn"
          onClick={() => setMktOpen(true)}
          className="mt-1 inline-flex items-center gap-1.5 text-sm font-medium text-[#26422A] underline underline-offset-2 hover:opacity-70"
        >
          <BookOpen className="h-4 w-4" /> {t("readFullText")}
        </button>
        <label
          htmlFor="consent-marketing"
          className="mt-3 flex cursor-pointer items-start gap-3"
        >
          <Checkbox
            id="consent-marketing"
            data-testid="consent-marketing-checkbox"
            checked={marketingChecked}
            onCheckedChange={(v) => setMarketingChecked(v === true)}
            className="mt-0.5 h-5 w-5 border-[#26422A] data-[state=checked]:bg-[#26422A] data-[state=checked]:text-[#FFEEBC]"
          />
          <span className="text-xs leading-snug text-[#26422A]">
            {MARKETING_DATA_CONSENT.checkbox}
          </span>
        </label>
      </div>

      {/* Section B — Commercial electronic message consent */}
      <div className="border-t border-[#26422A]/15 pt-5" data-testid="consent-commercial-section">
        <h3 className="text-sm font-semibold text-[#26422A]">
          {COMMERCIAL_MESSAGE_CONSENT.title}
        </h3>
        <button
          type="button"
          data-testid="open-commercial-text-btn"
          onClick={() => setComOpen(true)}
          className="mt-1 inline-flex items-center gap-1.5 text-sm font-medium text-[#26422A] underline underline-offset-2 hover:opacity-70"
        >
          <BookOpen className="h-4 w-4" /> {t("readFullText")}
        </button>
        <label
          htmlFor="consent-commercial"
          className="mt-3 flex cursor-pointer items-start gap-3"
        >
          <Checkbox
            id="consent-commercial"
            data-testid="consent-commercial-checkbox"
            checked={commercialChecked}
            onCheckedChange={(v) => setCommercialChecked(v === true)}
            className="mt-0.5 h-5 w-5 border-[#26422A] data-[state=checked]:bg-[#26422A] data-[state=checked]:text-[#FFEEBC]"
          />
          <span className="text-xs leading-snug text-[#26422A]">
            {COMMERCIAL_MESSAGE_CONSENT.checkbox}
          </span>
        </label>
      </div>

      <LegalTextModal open={mktOpen} onOpenChange={setMktOpen} doc={MARKETING_DATA_CONSENT} testid="marketing-text-modal" />
      <LegalTextModal open={comOpen} onOpenChange={setComOpen} doc={COMMERCIAL_MESSAGE_CONSENT} testid="commercial-text-modal" />
    </div>
  );
}
